<app-modal title="{{ 'components.billingDetailsConfirmationEmail.title' | translate }}">
  <div class="mb-8 mt-8">
    <p>{{ 'components.billingDetailsConfirmationEmail.content' | translate }}</p>
  </div>

  <button class="btn btn-primary font-bold inline-block" (click)="activeModal.close()">
    {{ 'general.close' | translate }}
  </button>
</app-modal>
